import React from "react"
import classnames from "classnames"
import styles from "./Image.less"
import debounce from "AtomicUtils/debounce"
import checkVisible from "AtomicUtils/checkVisible"
import { WINDOW } from "AtomicUtils/environment"
import { LoadingIcon } from "AtomicComponents"
import { IS_IE } from "AtomicUtils/environment"

class Image extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      model: "new",
      isIE: false
    }
  }

  componentDidMount() {
    const { src } = this.props
    if (!src) return
    this._checkVisibility()
    WINDOW.addEventListener("scroll", debounce(this._checkVisibility, 250), {
      passive: true
    })

    this.setState({
      isIE: IS_IE,
    })
  }

  componentDidUpdate(prevProps) {
    const { src } = this.props
    if (src !== prevProps.src) {
      this._loadImageInBackground({ model: "replace" })
    }
  }

  componentWillUnmount() {
    this._removeScrollEventListener()
  }

  _removeScrollEventListener = () => {
    WINDOW.removeEventListener("scroll", debounce(this._checkVisibility, 250), {
      passive: true
    });
  }


  _loadImageInBackground = ({ model = "new" }) => {
    const { src } = this.props
    const { loading } = this.state

    if (model === "new" && !loading) return

    this.setState({
      loading: true,
      model: model
    }, () => {
      let img = document.createElement("img")
      img.src = src
      let poll = setInterval(() => {
        if (this.image && img.naturalWidth) {
          clearInterval(poll)
          this.image.removeAttribute("data-src")
          this.image.setAttribute("src", src)
          setTimeout(() => {
            this.setState({ loading: false })
          }, 100)
        }
      }, 10)
    })
  }

  _checkVisibility = () => {
    const { loading } = this.state

    if (this.image && loading) {
      if (checkVisible(this.image)) {
        this._removeScrollEventListener()
        this._loadImageInBackground({ model: "new" })
      }
    } else {
      setTimeout(this._checkVisibility, 100)
    }
  }


  render() {
    let {
      src,
      type = "normal",
      alt,
      contain = false,
      draggable = true,
      fallbackSrc,
      loadingTheme = "dark"
    } = this.props

    const { loading, isIE } = this.state


    if (!src) return <div></div>

    if (!fallbackSrc) fallbackSrc = src

    if (type === "blurred") {
      fallbackSrc = `${fallbackSrc}?blur=10&quality=0.1`
    }

    if (type === "normal" || type === "withoutSpinner") {
      fallbackSrc = `${fallbackSrc}`
    }

    return (
      <div className={classnames({
        [styles.ImageContainer]: true,
        [styles.ImageContainerLoading]: type === "blurred" && loading,
        [styles.ImageContainerLight]: loadingTheme === "light",
        [styles.ImageContainerDark]: loadingTheme === "dark",
        [styles.ImageContainerContain]: contain && !isIE,
        [styles.ImageContainerIE]: isIE
      })} style={{minHeight: (loading) ? '67px' : ''}}>
        <img
          ref={c => (this.image = c)}
          src={fallbackSrc}
          data-src={src}
          alt={alt}
          draggable={draggable}
        />
        {
          loading &&
          type === "normal" &&
          <div className={classnames({
            [styles.LoadingLayer]: true,
          })}>
            <div className={classnames({
              [styles.LoadingIcon]: true,
            })}>
              <LoadingIcon />
            </div>
          </div>
        }
      </div>
    )
  }
}


export default Image



// WEBPACK FOOTER //
// ./src/AtomicContainers/Image/Image.jsx